import React from 'react'
import Button from '@mui/material/Button';


function Instructions() {
    return (
        <div >
            <ul className='quiz-instructions-list'>
                <li>Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima autem similique expedita nemo veritatis corporis architecto tenetur, sint molestiae repellat illum rem, totam ducimus aliquid quaerat cupiditate sit ullam in.</li>
                <li>Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima autem similique expedita nemo veritatis corporis architecto tenetur, sint molestiae repellat illum rem, totam ducimus aliquid quaerat cupiditate sit ullam in.</li>
                <li>Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima autem similique expedita nemo veritatis corporis architecto tenetur, sint molestiae repellat illum rem, totam ducimus aliquid quaerat cupiditate sit ullam in.</li>
                <li>Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima autem similique expedita nemo veritatis corporis architecto tenetur, sint molestiae repellat illum rem, totam ducimus aliquid quaerat cupiditate sit ullam in.</li>
                <li>Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima autem similique expedita nemo veritatis corporis architecto tenetur, sint molestiae repellat illum rem, totam ducimus aliquid quaerat cupiditate sit ullam in.</li>
            </ul>
           <Button className="start-quiz-button" variant='contained' size='large' >Start Quiz</Button>
        </div>
    )
}

export default Instructions
